/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'raigmore/location': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 26',
    data: '<path pid="0" d="M10 0C4.486 0 0 4.338 0 9.67c0 1.891.482 3.249 1.498 4.7l7.93 11.337A.695.695 0 0010 26c.229 0 .443-.11.571-.293l7.931-11.337C19.518 12.919 20 11.56 20 9.67c0-5.332-4.486-9.67-10-9.67V0zm0 1.334c4.77 0 8.62 3.724 8.62 8.336 0 1.693-.343 2.65-1.26 3.96L10 24.155 2.64 13.631c-.916-1.31-1.26-2.268-1.26-3.96 0-4.612 3.85-8.336 8.62-8.336v-.001zm0 3.334c-2.658 0-4.828 2.099-4.828 4.669 0 2.57 2.17 4.668 4.828 4.668 2.658 0 4.828-2.099 4.828-4.668 0-2.57-2.17-4.669-4.828-4.669zm0 1.334c1.913 0 3.448 1.485 3.448 3.335 0 1.85-1.535 3.334-3.448 3.334s-3.448-1.485-3.448-3.334c0-1.85 1.535-3.335 3.448-3.335z" _fill="#1B365D"/>'
  }
})
